export default {"src":"/_next/static/media/Subtract2.a489203c.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};